let client = null;
let settings = {
  logEvents: false,
};

export function setClient(newClient, newSettings) {
  client = newClient;
  if (newSettings) {
    settings = newSettings;
  }
}

export function getClient() {
  return client;
}

export function getSettings() {
  return settings;
}
